import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { VButton, VFlex, VStack, useUnleash } from '@/package';
import type { FrameData, Task } from '@/type';

import FrameListPagination from './FrameListPagination';
import FrameTable from './FrameTable';
import { WorkRedistributeModal } from './WorkRedistributeModal';

export const TaskFrameList = ({
  frameCount,
  frameList,
  taskDetail,
}: {
  frameCount: number;
  frameList: FrameData[];
  taskDetail: Task;
}) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const { isEnabled } = useUnleash();
  const isRedistributionEnabled =
    isEnabled('vuex.sapporo.redistribution') && frameList.length > 0;

  return (
    <>
      <VStack gap={0.5} className="h-full w-full max-w-[972px]">
        <VFlex items="center" justify="between">
          <VFlex className="px-2 text-body-xl text-gray-500" gap={0.5}>
            <span>Total</span>
            <span>{frameCount ?? 0}</span>
          </VFlex>

          {isRedistributionEnabled && (
            <VButton
              outlined
              size="md"
              variant="secondary"
              onClick={() => setVisible(true)}
            >
              {t('task.redistribute.ablactation')}
            </VButton>
          )}
        </VFlex>
        <div className="w-[972px] overflow-x-hidden">
          <FrameTable frameList={frameList} task={taskDetail} />
        </div>
        <div className="w-full pb-4">
          <FrameListPagination count={frameCount ?? 0} />
        </div>
      </VStack>

      {isRedistributionEnabled && (
        <WorkRedistributeModal
          key={taskDetail.id}
          visible={visible}
          setVisible={setVisible}
          task={taskDetail}
        />
      )}
    </>
  );
};
